import { QueryClient } from "@tanstack/react-query";
import { isApiError } from "./api/errors";

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: true,
        // Retry only things that can heal on their own; a 4xx will not.
        retry: (count, error) =>
          (!isApiError(error) || error.status === 0 || error.status >= 500) && count < 2,
      },
    },
  });
}
